// times, days and numbers for the channel's screens, always in the channel's own time zone (the encoder runs UTC)
const { clock } = window.RHL;
const timeZone = clock.timeZone;

const timeFormat = new Intl.DateTimeFormat('en-US', { timeZone, hour: 'numeric', minute: '2-digit' });
const dayFormat = new Intl.DateTimeFormat('en-US', { timeZone, weekday: 'short' });
const keyFormat = new Intl.DateTimeFormat('en-CA', {
	timeZone, year: 'numeric', month: '2-digit', day: '2-digit',
});

const toDate = (value) => (value instanceof Date ? value : new Date(value));

// "5:12 AM"
const time = (value) => timeFormat.format(toDate(value));
// "MON"
const weekday = (value) => dayFormat.format(toDate(value)).toUpperCase();
// "2026-10-25", the calendar day in the channel's time zone
const dayKey = (value) => keyFormat.format(toDate(value));
const isToday = (value, now = new Date()) => dayKey(value) === dayKey(now);

// "as of 10:45 PM", with the day when it isn't today
const asOf = (value, now = new Date()) => {
	if (!value) return '';
	const date = toDate(value);
	return `as of ${isToday(date, now) ? '' : `${weekday(date)} `}${time(date)}`;
};

const COMPASS = ['N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE', 'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW'];
const compass = (degrees) => (degrees === null || degrees === undefined ? '' : COMPASS[Math.round(degrees / 22.5) % 16]);

const feet = (value) => `${value.toFixed(1)} ft`;

// indexes and big prices without decimals, everything else with two
const price = (value) => {
	if (value === null || value === undefined) return '--';
	const digits = Math.abs(value) >= 1000 ? 0 : 2;
	return value.toLocaleString('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits });
};
// a plain hyphen for minus: the Star4000 fonts have no U+2212. Signed after rounding, so +0.04 reads 0.0%.
// Moves since the close are small, so they get two places.
const percent = (value, places = 1) => {
	if (value === null || value === undefined) return '--';
	const scale = 10 ** places;
	const rounded = Math.round(value * scale) / scale;
	const sign = rounded > 0 ? '+' : (rounded < 0 ? '-' : '');
	return `${sign}${Math.abs(rounded).toFixed(places)}%`;
};

export {
	timeZone,
	time,
	weekday,
	dayKey,
	isToday,
	asOf,
	compass,
	feet,
	price,
	percent,
};
